/**
 * AirportDetailsStep - Step 2 of the Location Wizard
 *
 * Displays airport detail fields auto-filled from the airport selection in Step 1.
 * All fields are optional and editable.
 */

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useLocationWizardStore } from '@/stores/locationWizardStore'

export function AirportDetailsStep() {
  const {
    iata_code,
    city,
    state_province,
    timezone,
    country,
    postal_code,
    phone_main,
    email_general,
    setIataCode,
    setCity,
    setStateProvince,
    setTimezone,
    setCountry,
    setPostalCode,
    setPhoneMain,
    setEmailGeneral,
  } = useLocationWizardStore()

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        These details were auto-filled from your airport selection. You can edit
        any field.
      </p>

      <div className="grid grid-cols-2 gap-4">
        {/* FAA/IATA Code */}
        <div className="space-y-2">
          <Label>FAA/IATA Code</Label>
          <Input
            value={iata_code}
            onChange={(e) => setIataCode(e.target.value)}
            placeholder="PHX"
            className="font-mono"
            maxLength={3}
          />
        </div>

        {/* Timezone */}
        <div className="space-y-2">
          <Label>Timezone</Label>
          <Input
            value={timezone}
            onChange={(e) => setTimezone(e.target.value)}
            placeholder="America/Phoenix"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* City */}
        <div className="space-y-2">
          <Label>City</Label>
          <Input
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="Phoenix"
          />
        </div>

        {/* State/Province */}
        <div className="space-y-2">
          <Label>State / Province</Label>
          <Input
            value={state_province}
            onChange={(e) => setStateProvince(e.target.value)}
            placeholder="AZ"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* Country */}
        <div className="space-y-2">
          <Label>Country</Label>
          <Input
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            placeholder="US"
          />
        </div>

        {/* Postal Code */}
        <div className="space-y-2">
          <Label>Postal Code</Label>
          <Input
            value={postal_code}
            onChange={(e) => setPostalCode(e.target.value)}
            placeholder="85034"
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* Phone */}
        <div className="space-y-2">
          <Label>Phone</Label>
          <Input
            value={phone_main}
            onChange={(e) => setPhoneMain(e.target.value)}
            placeholder="(602) 555-1234"
          />
        </div>

        {/* Email */}
        <div className="space-y-2">
          <Label>Email</Label>
          <Input
            type="email"
            value={email_general}
            onChange={(e) => setEmailGeneral(e.target.value)}
            placeholder="ops@fbo.com"
          />
        </div>
      </div>
    </div>
  )
}
